import { render } from "./SalesListsDetailsLayout.vue?vue&type=template&id=1d1380f3&scoped=true"
import script from "./SalesListsDetailsLayout.vue?vue&type=script&lang=js"
export * from "./SalesListsDetailsLayout.vue?vue&type=script&lang=js"

import "./SalesListsDetailsLayout.vue?vue&type=style&index=0&id=1d1380f3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d1380f3"]])

export default __exports__